export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_9-bdb64783afa68a46c905bb382e186940.jpg";